// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.2.6";import * as Sentry from '@sentry/nextjs';

import { anonymizeCookieHeader } from './helpers/anonymizeAccessCookies';
import pack from './package.json';

if (process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    // Anonymize access and refresh token cookies before sending the event to Sentry
    // This ensures that sensitive information, like access tokens or refresh tokens,
    // are not leaked to Sentry logs. Cookies ending with '-access' or '-refresh' will be replaced
    // with '[anonymized_token]' to prevent sending sensitive data.
    beforeSend(event) {
      if (event.request?.headers?.cookie) {
        event.request.headers.cookie = anonymizeCookieHeader(event.request.headers.cookie);
      }

      return event;
    },
    environment: process.env.SENTRY_ENV ?? process.env.APP_ENV,
    release: pack.version,

    tracesSampleRate:
      (process.env.SENTRY_ENV ?? process.env.APP_ENV) === 'production'
        ? 0.1
        : 0,
    integrations: [(Sentry.browserTracingIntegration)()],
    debug: false,
  });
}

// Export the router transition hook for navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
